// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3jqNB","text":"SelectPayment_text__2qKKu","title":"SelectPayment_title___zRqz","btn":"SelectPayment_btn__rb_H2"};